import { render, staticRenderFns } from "./LeftRight.vue?vue&type=template&id=6d7062a9&scoped=true"
import script from "./LeftRight.vue?vue&type=script&lang=js"
export * from "./LeftRight.vue?vue&type=script&lang=js"
import style0 from "./LeftRight.vue?vue&type=style&index=0&id=6d7062a9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7062a9",
  null
  
)

export default component.exports